/**
 * @override
 * 自定义积木，要采用统一样式，必须在定义积木样式， 
 * 设置output:'String/Number/Boolean/...'
 *
 * skulpt海龟库的教程文档：
 * https://runestone.academy/runestone/books/published/thinkcspy/PythonTurtle/OurFirstTurtleProgram.html 
 *
 */
import Blockly from 'blockly'

// 画笔
Blockly.Blocks['gta_turtle_pan'] = {
  init: function() {
    this.appendDummyInput().appendField('画笔')
    this.setOutput(true)
    this.setStyle('hat_blocks')
    this.setTooltip('')
    this.setInputsInline(true)
    this.setHelpUrl(Blockly.Msg['gta_turtle_pan'])
  },
}
Blockly.Python['gta_turtle_pan'] = function(block) {
  var code = 'gta_pen'
  return [code, Blockly.Python.ORDER_NONE]
}

//海龟动作-移动和绘制-前进
Blockly.Blocks['gta_turtle_forward'] = {
  init: function() {
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField('前进')
      .appendField(
        new Blockly.FieldDropdown([
          ['一', 'forward'],
          ['二', 'fd'],
        ]),
        'NAME1'
      )
    this.appendValueInput('NAME2').setCheck('Number')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('hat_blocks')
    this.setTooltip('前进一forward和前进二fd是效果一样的方法')
    this.setHelpUrl(Blockly.Msg['gta_turtle_forward'])
  },
}

Blockly.Python['gta_turtle_forward'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var dropdown_name1 = block.getFieldValue('NAME1')
  var num_name2 = Blockly.Python.valueToCode(
    block,
    'NAME2',
    Blockly.Python.ORDER_ATOMIC
  )

  var code = `${value_name}.${dropdown_name1}(${num_name2})\n`
  return code
}

// 海龟动作-移动和绘制-后退
Blockly.Blocks['gta_turtle_backward'] = {
  init: function() {
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField('后退')
      .appendField(
        new Blockly.FieldDropdown([
          ['一', 'backward'],
          ['二', ' bk'],
          ['三', ' back'],
        ]),
        'NAME1'
      )
    this.appendValueInput('NAME2').setCheck('Number')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('hat_blocks')
    this.setTooltip('后退一backward、后退二bk、后退三back是效果一样的方法')
    this.setHelpUrl(Blockly.Msg['gta_turtle_backward'])
  },
}

Blockly.Python['gta_turtle_backward'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var dropdown_name1 = block.getFieldValue('NAME1')
  var num_name2 = Blockly.Python.valueToCode(
    block,
    'NAME2',
    Blockly.Python.ORDER_ATOMIC
  )

  var code = `${value_name}.${dropdown_name1}(${num_name2})\n`
  return code
}

// 画笔旋转 - 废除
Blockly.Blocks['gta_turtle_rotate'] = {
  init: function() {
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField(
        new Blockly.FieldDropdown([
          ['向右', 'right'],
          ['向左', 'left'],
        ]),
        'NAME1'
      )
      .appendField('旋转')
      .appendField(new Blockly.FieldAngle(90), 'NAME2')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('hat_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_turtle_rotate'])
  },
}

Blockly.Python['gta_turtle_rotate'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  // console.log('value_name', value_name)
  var dropdown_name1 = block.getFieldValue('NAME1')
  var angle_name2 = block.getFieldValue('NAME2')
  var code = `${value_name}.${dropdown_name1}(${angle_name2})\n`
  return code
}

// 海龟动作-移动和绘制-右转
Blockly.Blocks['gta_turtle_right'] = {
  init: function() {
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField('右转')
      .appendField(
        new Blockly.FieldDropdown([
          ['一', 'right'],
          ['二', 'rt'],
        ]),
        'NAME1'
      )
      .appendField(new Blockly.FieldAngle(90), 'NAME2')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('hat_blocks')
    this.setTooltip('右转一right、右转二rt、是效果一样的方法')
    this.setHelpUrl(Blockly.Msg['gta_turtle_right'])
  },
}

Blockly.Python['gta_turtle_right'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var dropdown_name1 = block.getFieldValue('NAME1')
  var angle_name2 = block.getFieldValue('NAME2')
  var code = `${value_name}.${dropdown_name1}(${angle_name2})\n`
  return code
}

// 海龟动作-移动和绘制-左转
Blockly.Blocks['gta_turtle_left'] = {
  init: function() {
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField('左转')
      .appendField(
        new Blockly.FieldDropdown([
          ['一', 'left'],
          ['二', 'lt'],
        ]),
        'NAME1'
      )
      .appendField(new Blockly.FieldAngle(90), 'NAME2')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('hat_blocks')
    this.setTooltip('左转一right、左转二rt、是效果一样的方法')
    this.setHelpUrl(Blockly.Msg['gta_turtle_left'])
  },
}

Blockly.Python['gta_turtle_left'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  // console.log('value_name', value_name)
  var dropdown_name1 = block.getFieldValue('NAME1')
  var angle_name2 = block.getFieldValue('NAME2')
  var code = `${value_name}.${dropdown_name1}(${angle_name2})\n`
  return code
}

// goto
Blockly.Blocks['gta_turtle_goto'] = {
  init: function() {
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField('前往')
      .appendField(
        new Blockly.FieldDropdown([
          ['一', 'goto'],
          ['二', 'setpos'],
          ['三', ' setposition'],
        ]),
        'NAME3'
      )
      .appendField('X:')
      .appendField(new Blockly.FieldNumber(0), 'NAME1')
      .appendField('Y:')
      .appendField(new Blockly.FieldNumber(0), 'NAME2')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('hat_blocks')
    this.setTooltip(
      '前往一goto、前往二setpos、前往三setposition是效果一样的方法'
    )
    this.setHelpUrl(Blockly.Msg['gta_turtle_goto'])
  },
}

Blockly.Python['gta_turtle_goto'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var x = block.getFieldValue('NAME1')
  var y = block.getFieldValue('NAME2')
  var dropdown = block.getFieldValue('NAME3')
  var code = `${value_name}.${dropdown}(${x},${y})\n`
  return code
}

// setx_sety 设置x或y的坐标
Blockly.Blocks['gta_turtle_setx_sety'] = {
  init: function() {
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField('设置')
      .appendField(
        new Blockly.FieldDropdown([
          ['x', 'x'],
          ['y', 'y'],
        ]),
        'NAME1'
      )
      .appendField('坐标为：')
      .appendField(new Blockly.FieldNumber(0), 'NAME2')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('hat_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_turtle_setx_sety'])
  },
}

Blockly.Python['gta_turtle_setx_sety'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var axios = block.getFieldValue('NAME1')
  var num = block.getFieldValue('NAME2')
  var code = `${value_name}.set${axios}(${num})\n`
  return code
}

//设置朝向 画笔面向多少度
Blockly.Blocks['gta_turtle_setheading'] = {
  init: function() {
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField('设置朝向')
      .appendField(
        new Blockly.FieldDropdown([
          ['一', 'setheading'],
          ['二', 'seth'],
        ]),
        'NAME2'
      )
      .appendField(new Blockly.FieldNumber(90), 'NAME1')
      .appendField('度')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('hat_blocks')
    this.setTooltip('设置朝向一setheading和朝向二seth是一样的方法')
    this.setHelpUrl(Blockly.Msg['gta_turtle_setheading'])
  },
}

Blockly.Python['gta_turtle_setheading'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var angle = block.getFieldValue('NAME1')
  var dropdown = block.getFieldValue('NAME2')
  var code = `${value_name}.${dropdown}(${angle})\n`
  return code
}

//返回原点-新
Blockly.Blocks['gta_turtle_home'] = {
  init: function() {
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput().appendField('返回原点')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('hat_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_turtle_home'])
  },
}

Blockly.Python['gta_turtle_home'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')

  var code = `${value_name}.home()\n`
  return code
}

// 画圆/圆弧
Blockly.Blocks['gta_turtle_circle'] = {
  init: function() {
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField('画圆：半径')
      .appendField(new Blockly.FieldNumber(0), 'NAME1')
      .appendField('角度')
      .appendField(new Blockly.FieldNumber(360), 'NAME2')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('hat_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_turtle_circle'])
  },
}

Blockly.Python['gta_turtle_circle'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var radios = block.getFieldValue('NAME1')
  var angle = block.getFieldValue('NAME2')
  var code = `${value_name}.circle(${radios},${angle})\n`
  return code
}

// 绘制正多边形
Blockly.Blocks['gta_turtle_polygon'] = {
  init: function() {
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField('绘制')
      .appendField(new Blockly.FieldNumber(0), 'NAME1')
      .appendField('边形：外接圆的半径')
      .appendField(new Blockly.FieldNumber(0), 'NAME2')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('hat_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_turtle_polygon'])
  },
}

Blockly.Python['gta_turtle_polygon'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var steps = block.getFieldValue('NAME1')
  var radios = block.getFieldValue('NAME2')
  var code = `${value_name}.circle(${radios},steps=${steps})\n`
  return code
}

// 绘制圆dot
Blockly.Blocks['gta_turtle_dot'] = {
  init: function() {
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField('画点：')
      .appendField('直径')
      .appendField(new Blockly.FieldNumber(0), 'NAME1')
      .appendField('颜色')
      .appendField(new Blockly.FieldColour('#ff0000'), 'NAME2')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('hat_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_turtle_dot'])
  },
}

Blockly.Python['gta_turtle_dot'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var diameter = block.getFieldValue('NAME1')
  var color = block.getFieldValue('NAME2')
  var code
  if (color) {
    code = `${value_name}.dot(${diameter},${color})\n`
  } else {
    code = `${value_name}.dot(${diameter})\n`
  }
  return code
}

// 绘制圆dot 新
Blockly.Blocks['gta_turtle_dot_2'] = {
  init: function() {
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField('画点：')
      .appendField('直径')
      .appendField(new Blockly.FieldNumber(0), 'NAME1')
      .appendField('颜色')
    this.appendValueInput('NAME2').setCheck(null)
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('hat_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_turtle_dot_2'])
  },
}

Blockly.Python['gta_turtle_dot_2'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var diameter = block.getFieldValue('NAME1')
  var color = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  var code
  if (color) {
    code = `${value_name}.dot(${diameter},${color})\n`
  } else {
    code = `${value_name}.dot(${diameter})\n`
  }
  return code
}

// 撤销 新
Blockly.Blocks['gta_turtle_undo'] = {
  init: function() {
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput().appendField('撤销')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('hat_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_turtle_undo'])
  },
}

Blockly.Python['gta_turtle_undo'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var code = `${value_name}.undo()\n`
  return code
}

// 设置画笔速度
Blockly.Blocks['gta_turtle_speed'] = {
  init: function() {
    this.appendDummyInput().appendField('设置')
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField('速度')
      .appendField(new Blockly.FieldNumber(5), 'NAME1')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('hat_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_turtle_speed'])
  },
}

Blockly.Python['gta_turtle_speed'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var speed = block.getFieldValue('NAME1')
  var code = `${value_name}.speed(${speed})\n`
  return code
}

// 绘制文字印章write
Blockly.Blocks['gta_turtle_write'] = {
  init: function() {
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField('文字印章')
      .appendField(new Blockly.FieldTextInput('hello world'), 'NAME1')
      .appendField('字体')
      .appendField(new Blockly.FieldTextInput('Arial'), 'NAME2')
      .appendField('字号')
      .appendField(new Blockly.FieldNumber(10), 'NAME3')
      .appendField('类型')
      .appendField(
        new Blockly.FieldDropdown([
          ['正常', 'normal'],
          ['倾斜', 'italic'],
          ['加粗', 'bold'],
        ]),
        'NAME4'
      )
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('hat_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_turtle_write'])
  },
}

Blockly.Python['gta_turtle_write'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')

  var str = block.getFieldValue('NAME1')
  var font_family = block.getFieldValue('NAME2')
  var font_size = block.getFieldValue('NAME3')
  var font_type = block.getFieldValue('NAME4')
  var code = `${value_name}.write('${str}',font=('${font_family}',${font_size},'${font_type}'))\n`
  return code
}

// 重置
Blockly.Blocks['gta_turtle_reset'] = {
  init: function() {
    this.appendDummyInput()
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput().appendField(' 重置')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('hat_blocks')
    this.setTooltip(
      '从屏幕中删除海龟的绘图，海龟回到原点并设置所有变量为默认值。'
    )
    this.setHelpUrl(Blockly.Msg['gta_turtle_reset'])
  },
}

Blockly.Python['gta_turtle_reset'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var code = `${value_name}.reset()\n`
  return code
}

// 清空
Blockly.Blocks['gta_turtle_clear'] = {
  init: function() {
    this.appendDummyInput()
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput().appendField(' 清空')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('hat_blocks')
    this.setTooltip(
      '从屏幕中删除指定海龟的绘图。不移动海龟。海龟的状态和位置以及其他海龟的绘图不受影响。'
    )
    this.setHelpUrl(Blockly.Msg['gta_turtle_clear'])
  },
}

Blockly.Python['gta_turtle_clear'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var code = `${value_name}.clear()\n`
  return code
}

/** 获取海龟的状态*/

// 获取位置
Blockly.Blocks['gta_turtle_position'] = {
  init: function() {
    this.appendDummyInput()
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField('获取位置')
      .appendField(
        new Blockly.FieldDropdown([
          ['一', 'position'],
          ['二', 'pos'],
        ]),
        'NAME1'
      )
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('hat_blocks')
    this.setTooltip('位置一position、位置二pos方法的效果一样')
    this.setHelpUrl(Blockly.Msg['gta_turtle_position'])
  },
}

Blockly.Python['gta_turtle_position'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var position = block.getFieldValue('NAME1')
  var code = `${value_name}.${position}()\n`
  return code
}

// 获取海龟库朝向
Blockly.Blocks['gta_turtle_towards'] = {
  init: function() {
    this.appendDummyInput().appendField('获取')
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField(' 朝向 (X')
      .appendField(new Blockly.FieldNumber(0), 'NAME1')
      .appendField('Y')
      .appendField(new Blockly.FieldNumber(0), 'NAME2')
      .appendField(') 的角度')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('hat_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_turtle_towards'])
  },
}

Blockly.Python['gta_turtle_towards'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var axiosX = block.getFieldValue('NAME1')
  var axiosY = block.getFieldValue('NAME2')
  var code = `${value_name}.towards(${axiosX},${axiosY})\n`
  return code
}

// 设置画笔的x/y坐标
Blockly.Blocks['gta_turtle_cor'] = {
  init: function() {
    this.appendDummyInput().appendField('获取')
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField(' 的')
      .appendField(
        new Blockly.FieldDropdown([
          ['x', 'xcor'],
          ['y', 'ycor'],
        ]),
        'NAME1'
      )
      .appendField('坐标')
    this.setInputsInline(true)
    this.setOutput(true)
    this.setStyle('hat_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_turtle_cor'])
  },
}

Blockly.Python['gta_turtle_cor'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var cor = block.getFieldValue('NAME1')
  var code = `${value_name}.${cor}()`
  return [code, Blockly.Python.ORDER_FUNCTION_CALL]
}

//获取朝向
Blockly.Blocks['gta_turtle_heading'] = {
  init: function() {
    this.appendDummyInput().appendField('获取 ')
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput().appendField(' 朝向')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('hat_blocks')
    this.setTooltip('返回海龟当前的朝向')
    this.setHelpUrl(Blockly.Msg['gta_turtle_heading'])
  },
}

Blockly.Python['gta_turtle_heading'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var code = `${value_name}.heading()\n`
  return code
}

//获取距离
Blockly.Blocks['gta_turtle_distance'] = {
  init: function() {
    this.appendDummyInput().appendField('获取 ')
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField(' 到 (X:')
      .appendField(new Blockly.FieldNumber(0), 'NAME1')
      .appendField('Y:')
      .appendField(new Blockly.FieldNumber(0), 'NAME2')
      .appendField(') 距离')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('hat_blocks')
    this.setTooltip(
      '返回从海龟位置到由 (x,y)，适量或另一海龟对应位置的单位距离。'
    )
    this.setHelpUrl(Blockly.Msg['gta_turtle_distance'])
  },
}

Blockly.Python['gta_turtle_distance'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var x = block.getFieldValue('NAME1')
  var y = block.getFieldValue('NAME2')

  var code = `${value_name}.distance(${x},${y})\n`
  return code
}

// 设置度量单位
// 设置度量单位为角度
Blockly.Blocks['gta_turtle_degrees'] = {
  init: function() {
    this.appendDummyInput().appendField('设置 ')
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput().appendField(' 度量单位为角度')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('hat_blocks')
    this.setTooltip(
      '设置角度的度量单位，即设置一个圆周为多少 "度"。默认值为 360 度。'
    )
    this.setHelpUrl(Blockly.Msg['gta_turtle_degrees'])
  },
}

Blockly.Python['gta_turtle_degrees'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')

  var code = `${value_name}.degrees()\n`
  return code
}

Blockly.Blocks['gta_turtle_radians'] = {
  init: function() {
    this.appendDummyInput().appendField('设置 ')
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput().appendField(' 度量单位为弧度')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('hat_blocks')
    this.setTooltip('设置角度的度量单位为弧度。其值等于 degrees(2*math.pi)。')
    this.setHelpUrl(Blockly.Msg['gta_turtle_radians'])
  },
}

Blockly.Python['gta_turtle_radians'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')

  var code = `${value_name}.degrees()\n`
  return code
}
/** 画笔控制*/
// 画笔 落笔-抬笔
Blockly.Blocks['gta_turtle_penup_pendown'] = {
  init: function() {
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput().appendField(
      new Blockly.FieldDropdown([
        ['落笔', 'pendown'],
        ['抬笔', 'penup'],
      ]),
      'NAME1'
    )
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('turtle_control_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_turtle_penup_pendown'])
  },
}

Blockly.Python['gta_turtle_penup_pendown'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var pen_way = block.getFieldValue('NAME1')
  var code = `${value_name}.${pen_way}()\n`
  return code
}

// 画笔 落笔
Blockly.Blocks['gta_turtle_pendown'] = {
  init: function() {
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField('落笔 ')
      .appendField(
        new Blockly.FieldDropdown([
          ['一', 'pendown'],
          ['二', 'pd'],
          ['三', 'down'],
        ]),
        'NAME1'
      )
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('turtle_control_blocks')
    this.setTooltip(
      '画笔落下，移动时将画线（落笔一、落笔二、落笔三的方法效果一样）'
    )
    this.setHelpUrl(Blockly.Msg['gta_turtle_pendown'])
  },
}

Blockly.Python['gta_turtle_pendown'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var pen_way = block.getFieldValue('NAME1')
  var code = `${value_name}.${pen_way}()\n`
  return code
}

// 画笔 抬笔
Blockly.Blocks['gta_turtle_penup'] = {
  init: function() {
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField('抬笔 ')
      .appendField(
        new Blockly.FieldDropdown([
          ['一', 'penup'],
          ['二', 'pu'],
          ['三', 'up'],
        ]),
        'NAME1'
      )
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('turtle_control_blocks')
    this.setTooltip(
      '画笔抬起，移动时不画线。（抬起一、抬起二、抬起三的方法效果一样）'
    )
    this.setHelpUrl(Blockly.Msg['gta_turtle_penup'])
  },
}

Blockly.Python['gta_turtle_penup'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var pen_way = block.getFieldValue('NAME1')
  var code = `${value_name}.${pen_way}()\n`
  return code
}

// 设置笔画粗细
Blockly.Blocks['gta_turtle_pensize'] = {
  init: function() {
    this.appendDummyInput().appendField('设置')
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField('粗细')
      .appendField(new Blockly.FieldNumber(5), 'NAME1')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('turtle_control_blocks')
    this.setTooltip('设置画笔宽度')
    this.setHelpUrl(Blockly.Msg['gta_turtle_pensize'])
  },
}

Blockly.Python['gta_turtle_pensize'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var size = block.getFieldValue('NAME1')
  var code = `${value_name}.pensize(${size})\n`
  return code
}

// 画笔是否落下
Blockly.Blocks['gta_turtle_isdown'] = {
  init: function() {
    this.appendDummyInput()
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput().appendField('画笔是否落下')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('turtle_control_blocks')
    this.setTooltip('如果画笔落下返回 True，如果画笔抬起返回 False')
    this.setHelpUrl(Blockly.Msg['gta_turtle_isdown'])
  },
}

Blockly.Python['gta_turtle_isdown'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var code = `${value_name}.isdown()\n`
  return code
}

// 设置画笔颜色
Blockly.Blocks['gta_turtle_color'] = {
  init: function() {
    this.appendDummyInput().appendField('设置')
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField(' 颜色')
      .appendField(new Blockly.FieldColour('#ff0000'), 'NAME1')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setInputsInline(true)
    this.setStyle('turtle_control_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_turtle_color'])
  },
}

Blockly.Python['gta_turtle_color'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var pencolor = block.getFieldValue('NAME1')
  var code = `${value_name}.color('${pencolor}')\n`
  return code
}

// 设置画笔颜色
Blockly.Blocks['gta_turtle_pencolor'] = {
  init: function() {
    this.appendDummyInput().appendField('设置')
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField(' 笔头颜色')
      .appendField(new Blockly.FieldColour('#ff0000'), 'NAME1')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setInputsInline(true)
    this.setStyle('turtle_control_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_turtle_pencolor'])
  },
}

Blockly.Python['gta_turtle_pencolor'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var pencolor = block.getFieldValue('NAME1')
  var code = `${value_name}.pencolor('${pencolor}')\n`
  return code
}

// 设置画笔填充色
Blockly.Blocks['gta_turtle_fillcolor'] = {
  init: function() {
    this.appendDummyInput().appendField('设置')
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField(' 笔头填充色')
      .appendField(new Blockly.FieldColour('#ff0000'), 'NAME1')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setInputsInline(true)
    this.setStyle('turtle_control_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_turtle_fillcolor'])
  },
}

Blockly.Python['gta_turtle_fillcolor'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var fillcolor = block.getFieldValue('NAME1')
  // var code = `${value_name}.color('${fillcolor}')\n`
  var code = `${value_name}.fillcolor('${fillcolor}')\n`
  return code
}

// 画笔是否填充
Blockly.Blocks['gta_turtle_filling'] = {
  init: function() {
    this.appendDummyInput()
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput().appendField('画笔是否填充')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('turtle_control_blocks')
    this.setTooltip('返回填充状态 (填充为 True，否则为 False)。')
    this.setHelpUrl(Blockly.Msg['gta_turtle_filling'])
  },
}

Blockly.Python['gta_turtle_filling'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var code = `${value_name}.filling()\n`
  return code
}

// 设置画笔填充起点、终点
Blockly.Blocks['gta_turtle_begin_end_fill'] = {
  init: function() {
    this.appendDummyInput().appendField('设置当前点为')
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField('填充')
      .appendField(
        new Blockly.FieldDropdown([
          ['起点', 'begin_fill'],
          ['终点', 'end_fill'],
        ]),
        'NAME1'
      )
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setInputsInline(true)
    this.setStyle('turtle_control_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_turtle_begin_end_fill'])
  },
}

Blockly.Python['gta_turtle_begin_end_fill'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var begin_end = block.getFieldValue('NAME1')
  var code = `${value_name}.${begin_end}()\n`
  return code
}

// 设置新画笔
Blockly.Blocks['gta_turtle_set_pan'] = {
  init: function() {
    this.appendDummyInput().appendField('设置变量')
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput().appendField('为新画笔')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('turtle_screen_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_turtle_set_pan'])
  },
}

Blockly.Python['gta_turtle_set_pan'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var diameter = block.getFieldValue('NAME1')
  var code = `${value_name} = turtle.Turtle()\n`
  return code
}

/**海龟状态 */ 

// 隐藏/显示画笔
Blockly.Blocks['gta_turtle_hide_show'] = {
  init: function() {
    this.appendDummyInput().appendField(
      new Blockly.FieldDropdown([
        ['隐藏', 'hideturtle'],
        ['显示', 'showturtle'],
      ]),
      'NAME1'
    )
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setInputsInline(true)
    this.setStyle('turtle_status_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_turtle_hide_show'])
  },
}

Blockly.Python['gta_turtle_hide_show'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var name1 = block.getFieldValue('NAME1')
  var code = `${value_name}.${name1}()\n`
  return code
}

// 是否可见
Blockly.Blocks['gta_turtle_isvisible'] = {
  init: function() {
    this.appendDummyInput().appendField(' 是否可见')
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setInputsInline(true)
    this.setStyle('turtle_status_blocks')
    this.setTooltip('如果海龟显示返回 True，如果海龟隐藏返回 False。')
    this.setHelpUrl(Blockly.Msg['gta_turtle_isvisible'])
  },
}

Blockly.Python['gta_turtle_isvisible'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var code = `${value_name}.isvisible()\n`
  return code
}

//设置画笔形状shape
Blockly.Blocks['gta_turtle_shape'] = {
  init: function() {
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField('形状：')
      .appendField(
        new Blockly.FieldDropdown([
          ['箭头', 'arrow'],
          ['经典', 'classic'],
          ['海龟', 'turtle'],
          ['圆', 'circle'],
          ['方形', 'square'],
        ]),
        'NAME1'
      )
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setInputsInline(true)
    this.setStyle('turtle_status_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_turtle_shape'])
  },
}

Blockly.Python['gta_turtle_shape'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var shape = block.getFieldValue('NAME1')
  var code = `${value_name}.shape('${shape}')\n`
  return code
}

//大小调整模式
Blockly.Blocks['gta_turtle_resizemode'] = {
  init: function() {
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField('大小调整模式：')
      .appendField(
        new Blockly.FieldDropdown([
          ['auto', 'auto'],
          ['user', 'user'],
          ['noresize', 'noresize'],
        ]),
        'NAME1'
      )
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setInputsInline(true)
    this.setStyle('turtle_status_blocks')
    this.setTooltip(
      '设置大小调整模式为以下值之一: "auto", "user", "noresize"。如未指定 rmode 则返回当前的大小调整模式。'
    )
    this.setHelpUrl(Blockly.Msg['gta_turtle_resizemode'])
  },
}

Blockly.Python['gta_turtle_resizemode'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var mode = block.getFieldValue('NAME1')
  var code = `${value_name}.resizemode('${mode}')\n`
  return code
}

//调整形状大小
Blockly.Blocks['gta_turtle_shapesize'] = {
  init: function() {
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput()
      .appendField('调整大小：')
      .appendField(
        new Blockly.FieldDropdown([
          ['一', 'shapesize'],
          ['二', 'turtlesize'],
        ]),
        'NAME1'
      )
      .appendField(' 水平拉升：')
      .appendField(new Blockly.FieldNumber(), 'NAME2')
    this.appendDummyInput().appendField(' 垂直拉升：')
    .appendField(new Blockly.FieldNumber(), 'NAME3')
    this.appendDummyInput().appendField(' 粗细：')
    .appendField(new Blockly.FieldNumber(), 'NAME4')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setInputsInline(true)
    this.setStyle('turtle_status_blocks')
    this.setTooltip(
      '返回或设置画笔的属性 x/y-拉伸因子和/或轮廓。设置大小调整模式为 "user"。当且仅当大小调整模式设为 "user" 时海龟会基于其拉伸因子调整外观: stretch_wid 为垂直于其朝向的宽度拉伸因子，stretch_len 为平等于其朝向的长度拉伸因子，决定形状轮廓线的粗细。'
    )
    this.setHelpUrl(Blockly.Msg['gta_turtle_shapesize'])
  },
}

Blockly.Python['gta_turtle_shapesize'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var mode = block.getFieldValue('NAME1')
  var val2 = block.getFieldValue('NAME2')
  var val3 = block.getFieldValue('NAME3')
  var val4 = block.getFieldValue('NAME4')
  var code = `${value_name}.${mode}(${val2},${val3},${val4})\n`
  return code
}

// 剪切因子
Blockly.Blocks['gta_turtle_shearfactor'] = {
  init: function() {
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput().appendField(' 剪切因子')
    .appendField(new Blockly.FieldNumber(), 'NAME1')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setInputsInline(true)
    this.setStyle('turtle_status_blocks')
    this.setTooltip(
      '设置或返回当前的剪切因子。根据 share 指定的剪切因子即剪切角度的切线来剪切海龟形状。不 改变海龟的朝向 (移动方向)。如未指定 shear 参数: 返回当前的剪切因子即剪切角度的切线，与海龟朝向平行的线条将被剪切。'
    )
    this.setHelpUrl(Blockly.Msg['gta_turtle_shearfactor'])
  },
}

Blockly.Python['gta_turtle_shearfactor'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var val = block.getFieldValue('NAME1')
  var code
  if (val) {
    code = `${value_name}.shearfactor(${val})\n`
  } else {
    code = `${value_name}.shearfactor()\n`
  }
  return code
}

// 设置倾角
Blockly.Blocks['gta_turtle_settiltangle'] = {
  init: function() {
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput().appendField(' 设置倾角:')
    .appendField(new Blockly.FieldNumber(), 'NAME1')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setInputsInline(true)
    this.setStyle('turtle_status_blocks')
    this.setTooltip(
      '旋转海龟形状使其指向 angle 指定的方向，忽略其当前的倾角，不 改变海龟的朝向 (移动方向)。'
    )
    this.setHelpUrl(Blockly.Msg['gta_turtle_settiltangle'])
  },
}

Blockly.Python['gta_turtle_settiltangle'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var val = block.getFieldValue('NAME1')
  var code = `${value_name}.settiltangle(${val})\n`
  return code
}

// 设置倾斜
Blockly.Blocks['gta_turtle_tilt'] = {
  init: function() {
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput().appendField(' 倾斜:')
    .appendField(new Blockly.FieldNumber(), 'NAME1')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setInputsInline(true)
    this.setStyle('turtle_status_blocks')
    this.setTooltip(
      '海龟形状自其当前的倾角转动 angle 指定的角度，但 不 改变海龟的朝向 (移动方向)。'
    )
    this.setHelpUrl(Blockly.Msg['gta_turtle_tilt'])
  },
}

Blockly.Python['gta_turtle_tilt'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var val = block.getFieldValue('NAME1')
  var code = `${value_name}.tilt(${val})\n`
  return code
}

// 变形(获取变形或者设置变形)
Blockly.Blocks['gta_turtle_shapetransform'] = {
  init: function() {
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
      this.appendDummyInput()
      .appendField(' 变形: t11')
      .appendField(new Blockly.FieldNumber(), 'NAME1')
      .appendField(' t12 ')
      .appendField(new Blockly.FieldNumber(), 'NAME2')
      .appendField(' t21 ')
      .appendField(new Blockly.FieldNumber(), 'NAME3')
      .appendField(' t22 ')
      .appendField(new Blockly.FieldNumber(), 'NAME4')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setInputsInline(true)
    this.setStyle('turtle_status_blocks')
    this.setTooltip(
      '设置或返回海龟形状的当前变形矩阵。如未指定任何矩阵元素，则返回以 4 元素元组表示的变形矩阵。 否则就根据设置指定元素的矩阵来改变海龟形状，矩阵第一排的值为 t11, t12 而第二排的值为 t21, t22。 行列式 t11 * t22 - t12 * t21 必须不为零，否则会引发错误。 根据指定矩阵修改拉伸因子 stretchfactor, 剪切因子 shearfactor 和倾角 tiltangle。'
    )
    this.setHelpUrl(Blockly.Msg['gta_turtle_shapetransform'])
  },
}

Blockly.Python['gta_turtle_shapetransform'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var val = block.getFieldValue('NAME1')
  var val2 = block.getFieldValue('NAME2')
  var val3 = block.getFieldValue('NAME3')
  var val4 = block.getFieldValue('NAME4')
  var code = `${value_name}.shapetransform(${val},${val2},${val3},${val4})\n`
  return code
}

//  获取形状多边形
Blockly.Blocks['gta_turtle_get_shapepoly'] = {
  init: function() {
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
      this.appendDummyInput()
      .appendField(' 获取形状多边形')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setInputsInline(true)
    this.setStyle('turtle_status_blocks')
    this.setTooltip(
      '返回以坐标值对元组表示的当前形状多边形。这可以用于定义一个新形状或一个复合形状的多个组成部分。'
    )
    this.setHelpUrl(Blockly.Msg['gta_turtle_get_shapepoly'])
  },
}

Blockly.Python['gta_turtle_get_shapepoly'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var code = `${value_name}.get_shapepoly()\n`
  return code
}


/**海龟窗口*/ 
// TurtleScreen/Screen 方法  
// 设置背景颜色
Blockly.Blocks['gta_turtle_bgcolor'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('设置背景颜色')
      .appendField(new Blockly.FieldColour('#ff0000'), 'NAME1')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setInputsInline(true)
    this.setStyle('turtle_screen_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_turtle_bgcolor'])
  },
}

Blockly.Python['gta_turtle_bgcolor'] = function(block) {
  var bgcolor = block.getFieldValue('NAME1')

  var code = `turtle.Screen().bgcolor('${bgcolor}')\n`
  return code
}

// 背景图片
Blockly.Blocks['gta_turtle_bgpic'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('背景图片')
      this.appendValueInput('NAME1').setCheck()
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setInputsInline(true)
    this.setStyle('turtle_screen_blocks')
    this.setTooltip('设置背景图片或返回当前背景图片名称。如果 picname 为一个文件名，则将相应图片设为背景。如果 picname 为 "nopic"，则删除当前背景图片。如果 picname 为 None，则返回当前背景图片文件名。')
    this.setHelpUrl(Blockly.Msg['gta_turtle_bgpic'])
  },
}

Blockly.Python['gta_turtle_bgpic'] = function(block) {
  var pic = Blockly.Python.valueToCode(
    block,
    'NAME1',
    Blockly.Python.ORDER_ATOMIC
  )
  var code = `turtle.Screen().bgpic(${pic})\n`
  return code
}


//清屏
Blockly.Blocks['gta_turtle_clearscreen'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('清屏')
      .appendField(
        new Blockly.FieldDropdown([
          ['一', 'clearscreen'],
          ['二', 'clear'],
        ]),
        'NAME1'
      )
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setInputsInline(true)
    this.setStyle('turtle_screen_blocks')
    this.setTooltip('从中删除所有海龟的全部绘图。将已清空的 TurtleScreen 重置为初始状态: 白色背景，无背景片，无事件绑定并启用追踪。清屏一、清屏二的方法效果一样。')
    this.setHelpUrl(Blockly.Msg['gta_turtle_clearscreen'])
  },
}

Blockly.Python['gta_turtle_clearscreen'] = function(block) {
  var method = block.getFieldValue('NAME1')

  var code = `turtle.Screen().${method}()\n`
  return code
}
// 重置屏幕
Blockly.Blocks['gta_turtle_resetscreen'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('重置屏幕')
      .appendField(
        new Blockly.FieldDropdown([
          ['一', 'resetscreen'],
          ['二', 'reset'],
        ]),
        'NAME1'
      )
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setInputsInline(true)
    this.setStyle('turtle_screen_blocks')
    this.setTooltip('重置屏幕上的所有海龟为其初始状态。一和二的方法效一致。')
    this.setHelpUrl(Blockly.Msg['gta_turtle_resetscreen'])
  },
}

Blockly.Python['gta_turtle_resetscreen'] = function(block) {  
  var method = block.getFieldValue('NAME1')
  var code = `turtle.Screen().${method}()\n`
  return code
}

// 屏幕大小
Blockly.Blocks['gta_turtle_screensize'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('屏幕大小')
      .appendField(' 长')
      .appendField(new Blockly.FieldNumber(), 'NAME1')
      .appendField(' 宽')
      .appendField(new Blockly.FieldNumber(), 'NAME2')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setInputsInline(true)
    this.setStyle('turtle_screen_blocks')
    this.setTooltip('重置屏幕上的所有海龟为其初始状态。一和二的方法效一致。')
    this.setHelpUrl(Blockly.Msg['gta_turtle_screensize'])
  },
}

Blockly.Python['gta_turtle_screensize'] = function(block) {  
  var val1 = block.getFieldValue('NAME1')
  var val2 = block.getFieldValue('NAME2')
  var code = `turtle.Screen().screensize(${val1},${val2})\n`
  return code
}

// 设置世界坐标系
Blockly.Blocks['gta_turtle_setworldcoordinates'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('世界坐标系')
      .appendField(' 左下角X')
      .appendField(new Blockly.FieldNumber(), 'NAME1')
      .appendField(' 左下角Y')
      .appendField(new Blockly.FieldNumber(), 'NAME2')
      .appendField(' 右上角X')
      .appendField(new Blockly.FieldNumber(), 'NAME3')
      .appendField(' 右上角Y')
      .appendField(new Blockly.FieldNumber(), 'NAME4')

    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setInputsInline(true)
    this.setStyle('turtle_screen_blocks')
    this.setTooltip('设置用户自定义坐标系并在必要时切换模式为 "world"。这会执行一次 screen.reset()。如果 "world" 模式已激活，则所有图形将根据新的坐标系重绘。')
    this.setHelpUrl(Blockly.Msg['gta_turtle_setworldcoordinates'])
  },
}

Blockly.Python['gta_turtle_setworldcoordinates'] = function(block) {  
  var val1 = block.getFieldValue('NAME1')
  var val2 = block.getFieldValue('NAME2')
  var val3 = block.getFieldValue('NAME3')
  var val4 = block.getFieldValue('NAME4')
  var code = `turtle.Screen().setworldcoordinates(${val1},${val2},${val3},${val4})\n`
  return code
}

// 延迟
Blockly.Blocks['gta_turtle_delay'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('延迟')
      .appendField(new Blockly.FieldNumber(), 'NAME1')
      .appendField(' 毫秒')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setInputsInline(true)
    this.setStyle('turtle_screen_blocks')
    this.setTooltip('设置或返回以毫秒数表示的延迟值 delay。(这约等于连续两次画布刷新的间隔时间。) 绘图延迟越长，动画速度越慢。')
    this.setHelpUrl(Blockly.Msg['gta_turtle_delay'])
  },
}

Blockly.Python['gta_turtle_delay'] = function(block) {  
  var val1 = block.getFieldValue('NAME1')
  var code = `turtle.Screen().delay(${val1})\n`
  return code
}

// 延迟
Blockly.Blocks['gta_turtle_tracer'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('延迟')
      .appendField(new Blockly.FieldNumber(), 'NAME1')
      .appendField(' 毫秒')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setInputsInline(true)
    this.setStyle('turtle_screen_blocks')
    this.setTooltip('设置或返回以毫秒数表示的延迟值 delay。(这约等于连续两次画布刷新的间隔时间。) 绘图延迟越长，动画速度越慢。')
    this.setHelpUrl(Blockly.Msg['gta_turtle_tracer'])
  },
}

Blockly.Python['gta_turtle_tracer'] = function(block) {  
  var val1 = block.getFieldValue('NAME1')
  var code = `turtle.Screen().tracer(${val1})\n`
  return code
}





// 清空画笔
Blockly.Blocks['gta_turtle_clear'] = {
  init: function() {
    this.appendDummyInput().appendField('清空')
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setInputsInline(true)
    this.setStyle('turtle_screen_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_turtle_clear'])
  },
}

Blockly.Python['gta_turtle_clear'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var code = `${value_name}.clear()\n`
  return code
}


// 生成对话框
Blockly.Blocks['gta_turtle_textinput'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('对话框：标题')
      .appendField(new Blockly.FieldTextInput('对话框'), 'NAME1')
      .appendField('内容')
      .appendField(new Blockly.FieldTextInput('输入字符'), 'NAME2')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setInputsInline(true)
    this.setStyle('turtle_screen_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_turtle_textinput'])
  },
}

Blockly.Python['gta_turtle_textinput'] = function(block) {
  var title = block.getFieldValue('NAME1')
  var textInput = block.getFieldValue('NAME2')
  var code = `turtle.Screen.textinput('${title}','${textInput}')\n`
  return code
}

// 数字对话框
Blockly.Blocks['gta_turtle_numinput'] = {
  init: function() {
    this.appendDummyInput()
      .appendField('数字对话框：标题')
      .appendField(new Blockly.FieldTextInput('对话框'), 'NAME1')
      .appendField('内容')
      .appendField(new Blockly.FieldTextInput('输入数字'), 'NAME2')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setInputsInline(true)
    this.setStyle('turtle_screen_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_turtle_numinput'])
  },
}

Blockly.Python['gta_turtle_numinput'] = function(block) {
  var title = block.getFieldValue('NAME1')
  var numInput = block.getFieldValue('NAME2')
  var code = `turtle.Screen.numinput('${title}','${numInput}')\n`
  return code
}

//设置画笔标记 
Blockly.Blocks['gta_turtle_stamp'] = {
  init: function() {
    this.appendValueInput('NAME')
      .setCheck(null)
      .setAlign(Blockly.ALIGN_RIGHT)
    this.appendDummyInput().appendField(' 标记')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setInputsInline(true)
    this.setStyle('turtle_screen_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['gta_turtle_stamp'])
  },
}

Blockly.Python['gta_turtle_stamp'] = function(block) {
  var value_name = Blockly.Python.valueToCode(
    block,
    'NAME',
    Blockly.Python.ORDER_ATOMIC
  )
  value_name = value_name.replace(/\(|\)/g, '')
  var code = `${value_name}.stamp()\n`
  return code
}
